import { render, staticRenderFns } from "./OfferDetailContext.vue?vue&type=template&id=000d5bfb&"
import script from "./OfferDetailContext.vue?vue&type=script&lang=js&"
export * from "./OfferDetailContext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports